export default function getNameFromCommon(commonData: { id: number; name: string }[], id: number) {
  return commonData?.find((cd) => {
    return String(cd.id) === String(id);
  })?.name;
}
